import { Box, CircularProgress } from '@mui/material'

import { hubloTheme } from '@front/theme'

import type { ButtonVariant } from '../../../inputs/app-button/AppButton'

import { useCircularLoadingStyles } from './CircularLoading.styles'

export type CircularLoadingSize = 'small' | 'large'

interface CircularLoadingProps {
  size?: CircularLoadingSize
  color?: ButtonVariant | 'normal'
  className?: string
}

export const CircularLoading = ({
  size = 'large',
  color = 'normal',
  className,
}: CircularLoadingProps): JSX.Element => {
  const loaderSize = size === 'large' ? 100 : 25

  const { cx, classes } = useCircularLoadingStyles()

  const indicatorClassNames = cx([
    classes.absolute,
    {
      normal: classes.normalIndicator,
      primary: classes.whiteIndicator,
      secondary: classes.secondaryIndicator,
      'secondary-dark-bg': classes.whiteIndicator,
      delete: classes.whiteIndicator,
    }[color],
  ])

  const circleClassNames = cx([
    classes.circle,
    classes.absolute,
    {
      normal: classes.normalCircle,
      primary: classes.primaryCircle,
      secondary: classes.secondaryCircle,
      'secondary-dark-bg': classes.secondaryDarkBgCircle,
      delete: classes.deleteCircle,
    }[color],
  ])

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={cx(classes.root, className)}
      position="relative"
      data-testid="div_circular_loading"
      sx={{
        height: loaderSize,
        margin:
          size === 'large' ? hubloTheme.spacing(5, 0) : hubloTheme.spacing(0),
      }}
    >
      <CircularProgress
        className={indicatorClassNames}
        variant="determinate"
        size={loaderSize}
        thickness={3}
        value={100}
        title="circle-loading"
      />
      <CircularProgress
        className={circleClassNames}
        variant="indeterminate"
        disableShrink
        size={loaderSize}
        thickness={3}
      />
    </Box>
  )
}
